import React, { useEffect, useState } from 'react';
import { generatePath, Route, Switch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LearningCenterMobileView from './LearningCenterMobileView';
import routes from '../../../routes';
import VideoModule from '../Components/VideoModule';
import NeedToKnowModule from '../Components/NeedToKnowModule';
import QuizModule from '../Components/QuizModule';
import useActiveUser from '../../../hooks/useActiveUser';
import { setCoursesState } from '../../../actions/ui';
import { fetchUserCourses } from '../../../actions/users';

const LearningCenterMobileContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [currentCourse, setCurrentCourse] = useState({});
  const coursesState = useSelector((state) => state.ui.courses);
  const activeUser = useActiveUser();
  const courses = useSelector((state) => state.entities.users.courses);
  const userCourses = courses.byUserId[activeUser.id] || [];
  const videoTab = 'video';
  const needToKnowTab = 'need-to-know';
  const quizTab = 'quiz';

  useEffect(() => {
    dispatch(fetchUserCourses(activeUser.id));
  }, []);

  const handleModuleClick = (module, course) => {
    setCurrentCourse(course);
    history.push(generatePath(routes.mobileDashboardLearn, { tab: module, id: course.id }));
  };

  const paths = [
    generatePath(routes.mobileDashboardLearn),
    generatePath(routes.mobileDashboardLearn, { tab: videoTab }),
    generatePath(routes.mobileDashboardLearn, { tab: needToKnowTab }),
    generatePath(routes.mobileDashboardLearn, { tab: quizTab }),
  ];

  const setCurrentCoursesState = (courseId) => dispatch(setCoursesState(activeUser.id, courseId));

  return (
    <Switch>
      <Route exact path={paths[0]}>
        <LearningCenterMobileView
          isLoading={courses.inflight}
          videoTab={videoTab}
          needToKnowTab={needToKnowTab}
          quizTab={quizTab}
          courses={userCourses}
          onModuleClick={handleModuleClick}
          coursesState={coursesState}
          userId={activeUser?.id}
        />
      </Route>
      <Route path={paths[1]}>
        <VideoModule
          isMobile
          userId={activeUser?.id}
          course={currentCourse}
          nextTab={needToKnowTab}
          setCurrentCoursesState={setCurrentCoursesState}
        />
      </Route>
      <Route path={paths[2]}>
        <NeedToKnowModule
          isMobile
          userId={activeUser?.id}
          course={currentCourse}
          nextTab={quizTab}
          setCurrentCoursesState={setCurrentCoursesState}
        />
      </Route>
      <Route path={paths[3]}>
        <QuizModule
          isMobile
          userId={activeUser?.id}
          course={currentCourse}
          user={activeUser}
          setCurrentCoursesState={setCurrentCoursesState}
        />
      </Route>
    </Switch>
  );
};

export default LearningCenterMobileContainer;
